// Plain-language descriptions of common aircraft types, keyed by ICAO type designator.

export const TYPE_INFO = {
  A319: {
    name: "Airbus A319",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "120–150",
    blurb: "A shortened member of the A320 family, prized by airlines for its range and nimble short-runway performance.",
  },
  A320: {
    name: "Airbus A320",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "150–180",
    blurb: "One of the best-selling jets ever built, this is the everyday workhorse behind countless short and medium-haul flights.",
  },
  A321: {
    name: "Airbus A321",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "185–230",
    blurb: "The stretched big sibling of the A320, packing in more seats for busy routes while keeping the same friendly cockpit.",
  },
  A20N: {
    name: "Airbus A320neo",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "150–180",
    blurb: "A re-engined A320 with sleek wingtip 'sharklets' that sip noticeably less fuel than the original.",
  },
  A21N: {
    name: "Airbus A321neo",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "185–240",
    blurb: "The longest-range single-aisle Airbus, letting airlines fly transatlantic hops with efficient new-generation engines.",
  },
  A332: {
    name: "Airbus A330-200",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "210–250",
    blurb: "A twin-aisle long-hauler with a shorter fuselage tuned for reaching far-flung destinations.",
  },
  A333: {
    name: "Airbus A330-300",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "250–300",
    blurb: "A roomy twin-engine wide-body that has been a dependable long-haul favorite for decades.",
  },
  A339: {
    name: "Airbus A330-900neo",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "260–300",
    blurb: "A modernized A330 with new engines and a curved 'Sharklet' wing for quieter, thriftier long-haul flying.",
  },
  A343: {
    name: "Airbus A340-300",
    category: "Wide-body jet",
    engines: "4 jet engines",
    typicalSeats: "250–295",
    blurb: "A graceful four-engined long-hauler, easy to spot by its slender wings carrying a quartet of engines.",
  },
  A359: {
    name: "Airbus A350-900",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "300–350",
    blurb: "A carbon-fibre marvel with distinctive curved winglets, offering a whisper-quiet cabin on the world's longest routes.",
  },
  A388: {
    name: "Airbus A380-800",
    category: "Wide-body jet",
    engines: "4 jet engines",
    typicalSeats: "500–615",
    blurb: "The double-decker giant of the skies — the largest passenger airliner ever, with room for a small crowd on two full floors.",
  },
  B737: {
    name: "Boeing 737-700",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "126–149",
    blurb: "A compact classic-generation 737, the trusty backbone of many short-haul fleets around the globe.",
  },
  B738: {
    name: "Boeing 737-800",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "160–189",
    blurb: "Probably the most common jetliner you'll see at any airport, ferrying travelers on countless daily hops.",
  },
  B739: {
    name: "Boeing 737-900",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "180–215",
    blurb: "The stretched Next-Generation 737, squeezing in extra rows for airlines chasing lower cost per seat.",
  },
  B38M: {
    name: "Boeing 737 MAX 8",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "162–178",
    blurb: "The latest 737, wearing scalloped engine nacelles and split 'AT winglets' for markedly better fuel efficiency.",
  },
  B744: {
    name: "Boeing 747-400",
    category: "Wide-body jet",
    engines: "4 jet engines",
    typicalSeats: "400–420",
    blurb: "The iconic 'Queen of the Skies' with its unmistakable upper-deck hump — a true legend of long-haul travel.",
  },
  B748: {
    name: "Boeing 747-8",
    category: "Wide-body jet",
    engines: "4 jet engines",
    typicalSeats: "410–467",
    blurb: "The final and longest 747 ever built, blending the classic hump with modern wings borrowed from the Dreamliner era.",
  },
  B752: {
    name: "Boeing 757-200",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "180–239",
    blurb: "A powerful single-aisle rocket beloved by pilots, strong enough to cross the Atlantic despite having just one aisle.",
  },
  B763: {
    name: "Boeing 767-300",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "218–290",
    blurb: "A versatile twin-aisle that helped pioneer long over-water twin-engine flights and now hauls both people and cargo.",
  },
  B77W: {
    name: "Boeing 777-300ER",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "350–396",
    blurb: "A long-range heavyweight famous for the largest jet engines in the world, each nearly the width of a 737's cabin.",
  },
  B772: {
    name: "Boeing 777-200",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "300–350",
    blurb: "The original 'Triple Seven', a big twin-engine long-hauler that reshaped intercontinental flying in the 1990s.",
  },
  B788: {
    name: "Boeing 787-8 Dreamliner",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "240–250",
    blurb: "The first mostly-carbon-fibre airliner, offering bigger windows, cleaner air, and a smoother ride on long journeys.",
  },
  B789: {
    name: "Boeing 787-9 Dreamliner",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "280–300",
    blurb: "A stretched Dreamliner with graceful upswept wingtips, opening up ultra-long thin routes between distant cities.",
  },
  B78X: {
    name: "Boeing 787-10 Dreamliner",
    category: "Wide-body jet",
    engines: "2 jet engines",
    typicalSeats: "320–330",
    blurb: "The longest Dreamliner of the family, trading a little range for extra seats on high-demand long-haul routes.",
  },
  E170: {
    name: "Embraer E170",
    category: "Regional jet",
    engines: "2 jet engines",
    typicalSeats: "70–80",
    blurb: "A comfy Brazilian-built regional jet with a roomy double-bubble cabin and no dreaded middle seat.",
  },
  E190: {
    name: "Embraer E190",
    category: "Regional jet",
    engines: "2 jet engines",
    typicalSeats: "96–114",
    blurb: "A popular regional jet that bridges the gap to mainline flying, loved for its quiet, spacious 2-2 cabin.",
  },
  E195: {
    name: "Embraer E195",
    category: "Regional jet",
    engines: "2 jet engines",
    typicalSeats: "108–124",
    blurb: "The stretched E-Jet, giving smaller airlines big-jet reach on routes too thin for a full narrow-body.",
  },
  AT72: {
    name: "ATR 72",
    category: "Turboprop",
    engines: "2 turboprop engines",
    typicalSeats: "68–78",
    blurb: "A high-winged twin-turboprop, the go-to short-hop commuter that thrives on regional runways big jets skip.",
  },
  AT76: {
    name: "ATR 72-600",
    category: "Turboprop",
    engines: "2 turboprop engines",
    typicalSeats: "70–78",
    blurb: "The latest glass-cockpit ATR 72, quietly connecting islands and small towns with excellent fuel economy.",
  },
  DH8D: {
    name: "Bombardier Dash 8 Q400",
    category: "Turboprop",
    engines: "2 turboprop engines",
    typicalSeats: "70–90",
    blurb: "A speedy turboprop that nearly matches regional jets on time, using active noise cancellation for a calm cabin.",
  },
  CRJ9: {
    name: "Bombardier CRJ900",
    category: "Regional jet",
    engines: "2 jet engines",
    typicalSeats: "76–90",
    blurb: "A sleek, slim regional jet with a low-slung stance, a familiar sight feeding passengers into major hubs.",
  },
  BCS1: {
    name: "Airbus A220-100",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "100–120",
    blurb: "Originally the Bombardier CSeries, this clean-sheet jet offers wide windows and a surprisingly airy single-aisle cabin.",
  },
  BCS3: {
    name: "Airbus A220-300",
    category: "Narrow-body jet",
    engines: "2 jet engines",
    typicalSeats: "120–150",
    blurb: "The larger A220, blending regional-jet economics with mainline comfort and impressively quiet new-generation engines.",
  },
};

export function lookupType(typeCode) {
  if (!typeCode) return null;
  const key = String(typeCode).trim().toUpperCase();
  return TYPE_INFO[key] || null;
}
